export const PENDING_MFA_STORAGE_KEY = "pendingMfa";

export interface PendingMfaState {
  otpId: string;
  userId: number;
  maskedEmail: string | null;
  redirectUrl: string | null;
}
